import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from 'images/icons/drop-arrow.svg';

const CourseOverviewItem = ({ moduleData, isAllExpanded, showTopics }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(isAllExpanded);
  }, [isAllExpanded]);

  return (
    <div className="course-module">
      <button
        type="button"
        className="course-module-heading button-unstyled"
        style={{ padding: isExpanded ? '30px 0 14px 0' : '30px 0 30px 0' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div>
          <span className="course-module-title">{moduleData.title}</span>
          <span className="topic-count">
            {showTopics ? `${moduleData.topics.length} Topics` : ''}
          </span>
        </div>
        <span className="expand-arrow">
          <ArrowIcon
            style={isExpanded ? { transform: 'rotate(180deg)' } : {}}
          />
        </span>
      </button>

      <div
        className="course-module-topics"
        style={{
          maxHeight: isExpanded ? 500 : '',
        }}
      >
        <ul>
          {moduleData.topics.map((topic) => (
            <li>{topic}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

CourseOverviewItem.propTypes = {
  moduleData: PropTypes.object,
  isAllExpanded: PropTypes.bool,
  showTopics: PropTypes.bool,
};

export default CourseOverviewItem;
